import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import { fetchGetChatId, TGetChatIdResponse } from 'shared/repositories/cpd/v1/get-chat-id';
import { selectCpdDraftId } from 'shared/selectors/cpd/cpd';
import { IThunkActionCreator } from 'shared/store';

export const getCpdChatId =
  (): IThunkActionCreator<Promise<string | null | undefined>> => async (dispatch, getState, context) => {
    try {
      const state = getState();
      const cpdDraftId = selectCpdDraftId(state);

      if (!cpdDraftId) {
        return null;
      }

      const resCpdChat = (await fetchGetChatId({
        httpApi: context.httpApi,
        parameters: {
          cpdDraftId,
        },
      })) as TGetChatIdResponse;

      if (resCpdChat.statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          statusCode: resCpdChat.statusCode,
          domain: 'createDraftCpd.ts',
          message: resCpdChat.response.message as string,
        });
      }

      const { chatId } = resCpdChat.response;

      return chatId;
    } catch (e) {
      context.logger.error(e);

      return null;
    }
  };
